// extracted by mini-css-extract-plugin
export default {"tooltip":"po-z","sharingV2":"qo-z","sharingIconsV2":"ro-z","links":"so-z","link":"to-z","facebookV2":"uo-z","twitterV2":"vo-z","pinterestV2":"wo-z"};